
const state = {
  app_list: [
    {
      id: 0,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/material%20(1).png',
      name: '智能图像编辑',
      tmp: null,
      show: false
    },
    {
      id: 1,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/Premium%20Application.png',
      name: '替换甲片',
      tmp: null,
      show: false
    },
    {
      id: 7,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/test-change.png',
      name: '替换甲片',
      tmp: null
    },
    {
      id: 2,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/material%20(6).jpg',
      name: '皮肤质感增强',
      tmp: null,
      show: false
    },
    {
      id: 8,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/ProductRetouching.png',
      name: '多模态ai修图/生图',
      tmp: null
    },
    {
      id: 3,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/Multi-angle_product.png',
      name: '多角度生成',
      tmp: null
    },
    {
      id: 11,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/BlendImage.png',
      name: '光影溶图',
      tmp: null
    },
    {
      id: 6,
      cover: 'https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/test/rytnhgbvrfdc.png',
      name: '视频生成',
      tmp: null
    },
    {
      id: 4,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/VideoEditing.png',
      name: '视频剪辑与拼接',
      tmp: null
    },
    {
      id: 9,
      cover: 'https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/test/asdasdasdasdasd.png',
      name: '视频脚本反推与抽帧',
      tmp: null
    },
    {
      id: 5,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/migrate.png',
      name: '万物迁移',
      tmp: null
    },
    {
      id: 10,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/Nail%20Retouching.png',
      name: '色卡修图',
      tmp: null
    },
    {
      id: 12,
      cover: 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/premium_app/VideoStitching.png',
      name: '视频拼接',
      tmp: null
    }
  ]
}

export default {
  namespaced: true,
  state
}
